import React from 'react';
import { NotificationBell } from 'features/notifications/components/NotificationBell';

/**
 * HeaderNotificationBell Component
 * 
 * Wrapper component for the notification bell in the header.
 * This component is used in the header configuration.
 */
export const HeaderNotificationBell: React.FC = () => {
    return <NotificationBell compact />;
};

